<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  *ngIf="navigation$ | async"
  class="dark bg-gray-900 print:hidden"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="(navigation$ | async)?.compact"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo container with relative positioning -->
    <div
      class="relative flex items-center justify-center h-20 mt-3 mb-4 cursor-pointer"
      [routerLink]="['/']"
    >
      <div *ngIf="!currentUser?._company?._logo">
        <!-- Main Logo -->
        <img
          *ngIf="!lightMode"
          class="w-full max-w-[180px]"
          src="assets/images/logo/leroux-logo-long-on-dark.png"
          alt="Leroux Logo"
        />
        <img
          *ngIf="lightMode"
          class="w-full max-w-[180px]"
          src="assets/images/logo/leroux-logo-long-on-dark.png"
          alt="Logo image"
        />
      </div>
      <div *ngIf="currentUser?._company?._logo">
        <!-- Main Logo -->
        <!-- <img *ngIf="!lightMode" class="w-full max-w-[180px]" src="assets/images/logo/logo-on-black-header.png"
                    alt="Logo image"> -->
        <img
          *ngIf="!lightMode"
          class="w-full max-w-[100px]"
          src="assets/images/logo/leroux-logo-long-on-dark.png"
          alt="Logo image"
        />
      </div>
      <!-- New Logo (Positioned at the top-right of the existing logo) -->
      <img
        class="absolute bottom-[-25px] right-10 w-10 h-10 transform translate-x-1 -translate-y-2 rounded-full"
        *ngIf="currentUser?._company?._logo"
        src="{{ currentUser?._company?._logo.url }}"
        alt="New Logo"
      />
    </div>
  </ng-container>

  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <div
      class="flex flex-col items-center gap-2 px-4 py-4 border-t border-white/10"
    >
      <span class="text-[10px] text-gray-400 text-center leading-tight">
        Logiciel réalisé par
      </span>
      <img
        class="h-6 w-auto object-contain opacity-60"
        src="assets/images/logo/yaakadev-logo.png"
        alt="Logo Yaakadev"
      />
      <span class="text-[10px] text-gray-400 text-center leading-tight">
        pour Le Roux TP
      </span>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b dark:border-gray-800 bg-card dark:bg-transparent print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!-- <languages></languages> -->
      <button
        *ngIf="hasActiveNotes$ | async"
        mat-icon-button
        matTooltip="Informations"
        (click)="openInfosDialog()"
      >
        <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
      </button>
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <scheme-toggle></scheme-toggle>
      <!-- <notifications></notifications> -->
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>
